import React from "react";

import Layout from "../../components/layout";
import SEO from "../../components/SEO";
import { BlankCanvasDaoProjectSection } from "../../containers/projects";

const BlankCanvasDaoProjectPage = () => {
  return (
    <Layout>
      <SEO
        title="Blank Canvas DAO - Projects"
        description="Redesign and feature work on Blank Studio's canvas-to-NFT web app | Web3, E-Commerce | Year: 2022 | Typescript, React, Next.js, Prismic CMS, Framer Motion, GSAP"
      />
      <BlankCanvasDaoProjectSection />
    </Layout>
  );
};

export default BlankCanvasDaoProjectPage;
